export const createFormValidation = (
	validateValues: Record<string, ((value: unknown) => [boolean, string])[]>
) => (formData: Record<string, unknown>): boolean => {
	return Object.keys(formData).every((key) => {
		const validators = validateValues[key] || []
		return validators.every((validator) => !validator(formData[key])[0])
	})
}
